import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class TicketCategoryService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }
  getAllTicketCategoryService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.ticketCategoryServiceURLS.getTicketCategory,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getTicketCategoryById = async (session_id, ticketCategoryId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.ticketCategoryServiceURLS.getTicketCategorysById +
          `${ticketCategoryId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAllTicketCategoryStatusService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.ticketCategoryServiceURLS.getAllTicketCategorySegments,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  createTicketCategory = async (
    session_id,
    ticketCategory,
    apiUrl = this.constants.ticketCategoryServiceURLS.postTicketCategory
  ) => {
    try {
      return await this.HttpService.postJson(
        apiUrl,
        {
          accountId: ticketCategory.accountId,
          id: ticketCategory.ticketCategoryId,
          name: ticketCategory.ticketCategoryName,
          code: ticketCategory.ticketCategoryName,
          status: "ACT",
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  editTicketCategory = async (session_id, ticketCategory) => {
    try {
      return await this.HttpService.putJson(
        this.constants.ticketCategoryServiceURLS.editTicketCategory,
        {
          accountId: ticketCategory.accountId,
          id: ticketCategory.ticketCategoryId,
          name: ticketCategory.ticketCategoryName,
          code: ticketCategory.ticketCategoryName,
          status: "ACT",
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  deleteTicketCategory = async (session_id, ticketCategoryId) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.ticketCategoryServiceURLS.getTicketCategory +
          `${ticketCategoryId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
}
